import { defineMessages } from "react-intl";

export default defineMessages({
  bankTransfer: {
    id: "payWithBankTransfer.bankTransfer",
    defaultMessage: "Bank Transfer",
  },
});
